import classNames from "classnames";
import { useEffect, useRef, useState } from "react";

import styles from "./Legend.module.css";

const navigation = [
  { anchor: "#timeline", title: "Timeline" },
  { anchor: "#our-values", title: "Our Values" },
  { anchor: "#team", title: "Team" },
  { anchor: "#how-we-work", title: "How we Work" },
  { anchor: "#our-benefits", title: "Our Benefits" },
  { anchor: "#open-positions", title: "Open Positions" },
  { anchor: "#hiring-process", title: "Hiring Process" },
  { anchor: "#investors", title: "Investors" },
];

const Legend = () => {
  const [activeItem, setActiveItem] = useState<string>(navigation[0].anchor);
  const itemsRef = useRef<HTMLAnchorElement[]>([]);

  function updateSidebarOnScroll() {
    const fromTop = window.scrollY;
    let currentPossibleAnchor = itemsRef.current[0];
    const offset = 100;

    itemsRef.current.forEach((link) => {
      try {
        const section: HTMLHeadingElement | null = document.querySelector(decodeURIComponent(link.hash));
        if (!section) {
          return;
        }
        const isBelow = section.offsetTop - offset <= fromTop;
        if (isBelow) currentPossibleAnchor = link;
      } catch (error) {}
    });

    if (currentPossibleAnchor) {
      setActiveItem(currentPossibleAnchor.hash);
    }
  }

  useEffect(() => {
    function scrollHandler() {
      window.requestAnimationFrame(updateSidebarOnScroll);
    }

    window.addEventListener("scroll", scrollHandler);

    return () => {
      window.removeEventListener("scroll", scrollHandler);
    };
  }, []);

  return (
    <div className={styles.legend}>
      {navigation.map((item, index) => (
        <a
          href={item.anchor}
          key={item.anchor}
          ref={(el) => {
            if (el) {
              itemsRef.current[index] = el;
            }
          }}
          className={classNames(styles.link, { [styles.active]: activeItem === item.anchor })}
        >
          <span>{item.title}</span>
        </a>
      ))}
    </div>
  );
};

export default Legend;
